<template>
  <el-popover
    v-model="popoverVisible"
    popper-class="input-number-pop"
    placement="top-start"
    :content="content"
    trigger="manual"
  >
    <template #reference>
      <el-input
        ref="elInput"
        v-model="agValue"
        :class="['input-number', hasError ? 'error-input' : '']"
        v-bind="componentProps"
        clearable
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.native="handleKeyup"
        @keydown.native="handleKeydown"
        @clear="clear"
      />
    </template>
  </el-popover>
</template>

<script>

import agEditorMixins from './ag-editor-mixins'
import { Popover as ElPopover, Input as ElInput } from 'element-ui'
export default {
  name: 'AgGridInput',
  components: {
    ElPopover,
    ElInput
  },
  mixins: [agEditorMixins],
  props: {

  },
  data() {
    return {
      popoverVisible: false,
      hasError: false,
      agValue: undefined,
      content: undefined
    }
  },
  computed: {
    componentProps() {
      return Object.assign(
        {},
        {
          placeholder: this.$t?.('components.pleaseEnter'),
          size: 'mini',
          hasErrorCancel: true
        },
        this.params?.cellEditorComponentProps || {}
      )
    }
  },
  mounted() {
    this.agValue = this.params.value
    this.$nextTick(() => {
      const { autoFocus } = this.componentProps
      if (autoFocus) {
        this.focus()
      }
    })
  },
  methods: {
    isCancelAfterEnd() {
      return this.componentProps.hasErrorCancel ? false : this.hasError
    },
    triggerChange() {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { change } = cellEditorComponentProps || {}

      change?.(this.agValue, { agParams: restAgParams })
    },

    // 监听键盘事件
    handleKeyup(e) {
      this.triggerKeyup(e)
    },
    // 监听键盘事件
    handleKeydown(e) {
      this.triggerKeydown(e)
    },
    focus() {
      this.$refs.elInput.focus()
    },
    blur() {
      this.$refs.elInput.blur()
    },
    // 清空事件
    clear() {
      this.focus()
      this.triggerChange()
    },
    // 失焦事件
    handleBlur(e) {
      this.triggerBlur(e)
    },
    // 聚焦事件
    handleFocus(e) {
      this.validate()
      if (this.hasError) {
        this.popoverVisible = true
      }

      const { focusSelect } = this.componentProps

      if (focusSelect) {
        this.$nextTick(() => {
          e.target.select()
        })
      }

      this.triggerFocus(e)
    },
    validate() {
      const { rule, msg } = this.componentProps

      if (rule && this.agValue) {
        rule(this.params, this.agValue)
          .then((res) => {
            this.content = msg
            if (res.data) {
              this.hasError = true
              this.popoverVisible = this.hasError
            } else {
              this.hasError = false
              this.popoverVisible = this.hasError
            }
          })
          .catch((err) => {
            this.hasError = true
            this.popoverVisible = this.hasError
            this.content = err || msg
          })
      }
    },
    // 输入事件
    handleInput() {
      this.validate()

      this.triggerChange()
    }
  }
}
</script>
